
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqgi884xPKEUwI4zYZ4fhMEIQ1wqJBJewjMJzkM9pw0JgMeta } from "/codebuild/output/src839969302/src/src/pages/faq.vue?macro=true";
import { default as menu5QyYz1d4PLBMcyj4iC3wjShero98_sv8VkYGpaNf0TsMeta } from "/codebuild/output/src839969302/src/src/pages/menu.vue?macro=true";
import { default as indexPQOs9bCROpPq2Ze9uYyu7aO5N4p9Bl17gH_8pmIy2gYMeta } from "/codebuild/output/src839969302/src/src/pages/index.vue?macro=true";
import { default as contacty1r98Z_45hz04Hkz0kCy1f793kmoqy3c_45v0FtWMtbRx28Meta } from "/codebuild/output/src839969302/src/src/pages/contact.vue?macro=true";
import { default as tutorialaqiHvXQ_4531e_QFlnBebx_gerg1R95oO_r6JCqF2FPbIMeta } from "/codebuild/output/src839969302/src/src/pages/tutorial.vue?macro=true";
import { default as agreementf7_6BhMCzIVA4yNgN4RAKGEfAv4bjnqhuo3nuCU7LMMMeta } from "/codebuild/output/src839969302/src/src/pages/agreement.vue?macro=true";
import { default as about_45passFQNCQa_NH72aizskRszWWN69Ip_6jQX8IAFdDTB6AZMMeta } from "/codebuild/output/src839969302/src/src/pages/about-pass.vue?macro=true";
import { default as indexqWe5UFguKigTGyGt9ti1bR2Tg1_KsikTyWsypeBFjYgMeta } from "/codebuild/output/src839969302/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93L56BMuVg6WWT6XpFWDyEu2lHD9pe_45gQ1D_AoKS5ZTd4Meta } from "/codebuild/output/src839969302/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceE9_TV9rJEg8nOVY3LkQJ6AUpIzqXQMEzLYS_b3wO2eAMeta } from "/codebuild/output/src839969302/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93QhtQobrqWyREMxbbJY5G7OfwE_CLFsE_45Cguava1Hc10Meta } from "/codebuild/output/src839969302/src/src/pages/notice/[id].vue?macro=true";
import { default as indexi8bFSmPkUTlwOt5rq9oD7JWDMk1wIDPylx4ypqLchLoMeta } from "/codebuild/output/src839969302/src/src/pages/coupon/index.vue?macro=true";
import { default as indexoydMqjRbVEqkUoDamd6efkp86iBZlr23m2GUhQ983H8Meta } from "/codebuild/output/src839969302/src/src/pages/mypage/index.vue?macro=true";
import { default as indexG2fnjYH_T7T57fwKrqvSMJWFC6q2zPfYSIyuJjZS5K4Meta } from "/codebuild/output/src839969302/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93O6NZuwsUH6oVAIF8FWIGUx4_45yu9DCpiBhCm_Z4jMG9YMeta } from "/codebuild/output/src839969302/src/src/pages/parking/[id].vue?macro=true";
import { default as indexZRk7RvGvUAvj8lSFct_i5bHufcYXErwEXsPhSMNfUdgMeta } from "/codebuild/output/src839969302/src/src/pages/history/index.vue?macro=true";
import { default as index79ea2ZY1yDG3sFmOF_HLMcPj9b9BuOicABysL9Z4IUwMeta } from "/codebuild/output/src839969302/src/src/pages/monthly/index.vue?macro=true";
import { default as indexxV632rTsF9TkRNC8ozhm9L8FMsq_EFgwjthyOYTWdD4Meta } from "/codebuild/output/src839969302/src/src/pages/sign-in/index.vue?macro=true";
import { default as index0Pe09GVcKNiDV_hAJiVWhvD9nuwWjopj6ZA_R6Sr_4sMeta } from "/codebuild/output/src839969302/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviWAJZLEUii7ShKf1Pzj5PXWcHRvhwlSA9X8vFuZPmN44Meta } from "/codebuild/output/src839969302/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editmibPb8PhO06jtxbBXUUi_nq_45hXBmwsHvphzV5aJ3BjcMeta } from "/codebuild/output/src839969302/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementvSkAQmyzgwZKiSkkSB3C7FIVY0YhHacNi6R_45NqBLav8Meta } from "/codebuild/output/src839969302/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexfGXRIin0y3YJ0Y78X823IwgE_6864yHp9wQRvAnTsx0Meta } from "/codebuild/output/src839969302/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dNKPXger8ksnNzR7IgxW35CcD_Ud3bQ4q7i2JLvT_oYMMeta } from "/codebuild/output/src839969302/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmgmdkRBqOcyrfrN7hDrBDqpXNKYxsTeZC3Qi4HAD0yMQMeta } from "/codebuild/output/src839969302/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexRSz31PkkVtTWodsCbSX3iBpzz9IZT8iDJN7eP2Z1rNQMeta } from "/codebuild/output/src839969302/src/src/pages/card/create/index.vue?macro=true";
import { default as indexCMwiO6t6_45EjA6kEeI6lPFFkPwqSn2IqBmftnx2iJNcsMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmMN1KkZ96mCy8fa2wh6ChocMDmCHlw50APMYAZ2Xbz2YMeta } from "/codebuild/output/src839969302/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmc_45NjzyH_F4Xuurj_Of636Hchm4vHz7TkadYF02IXsrsMeta } from "/codebuild/output/src839969302/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completenDLjZiSu0m9OXhXqT_5_Eor9v2eZ3Dew_LBlN8LRG5sMeta } from "/codebuild/output/src839969302/src/src/pages/membership/complete.vue?macro=true";
import { default as registerxbj1nQA1dkrzhZaQ1ejhaPQSBNpEeb_45k2IQUgmIm5TAMeta } from "/codebuild/output/src839969302/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93GoLLMZ05ZMt4kp3038mL7CnEUWkse_LV92znothqsOIMeta } from "/codebuild/output/src839969302/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm_Cr_Jumfxozz47OYbgfXNhxgVfA2iYLPdxCnNNaj0dUMeta } from "/codebuild/output/src839969302/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93RUm84umZtE_11NMK2mrg3SWHL7mWjDNNSpkdXTJr_451IMeta } from "/codebuild/output/src839969302/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexh_45mtUN3xv8vUweZsGOE5jA95GmV397RiBWBZZAowFDUMeta } from "/codebuild/output/src839969302/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeyFmzNm9eSDZp7N1MH84k54CpiWDgtEK_xPAluKn7PwkMeta } from "/codebuild/output/src839969302/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeZV5Yx5XVjGN_45oa_45MSiepO_451nDZ5Lg6aY00nM9dISwyAMeta } from "/codebuild/output/src839969302/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeLwXicsPjlO0zGzHLYYUFiCrv4769Txj5q1SIWzLVSxQMeta } from "/codebuild/output/src839969302/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerSOITTUHIPaDR4pbrELcU03cVc2cCFdGil1YcjuCbQawMeta } from "/codebuild/output/src839969302/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeFelMKc_tP78GlRYmAnQI6EGct_W_45CwKkV3BqpxDUgIMMeta } from "/codebuild/output/src839969302/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexuds61odVu6DWPXVTjPnuNmoZaxxVU5A5HsYc2sdLL8kMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirm9sXpgC41pIfYzw33QSWBqmj4BLW0B39D6xrJBpx1TMsMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeNDxL4Tv9MYwh8c23EP1Bmo1h_1FDIRW99hOZ9HlMHOgMeta } from "/codebuild/output/src839969302/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexqroS63owgDJgcLtDS8gZZM84uQSBN7UofZe5nLFLa0AMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93REG922he3ZVd7Qbo_C3TcHXP6qBt8XZ7AXrgjiN8VWMMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completecyactynqxJaeEsDP92qpkWwUc0O76BG2bjhkN_XGfbAMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasMoan0tSYIBwLeufhj2N_DkmkeEDg8ClnSiXYaOrswI8Meta } from "/codebuild/output/src839969302/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample2dTIqhHd_N_45pDdw7eNUzt8HruoRF4aewrKZF5faMh5EMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email_rL_pFywC_45fRmnLd7z7heI88vp_knHCX_8K69glnLq4Meta } from "/codebuild/output/src839969302/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmaG4y316rHGsyYNqTM7KEPsm8SvU1X94WOw_45PpBJU8kIMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentgo46_45FYPQIT48A_453GL3c1wLVkv4CTPo4rWdQTrqPk8IMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm31KIoLeBqqr0HhsZbgaVyStMBejkpWbrRo_HSxMVv1gMeta } from "/codebuild/output/src839969302/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateSNasUfYKa9CFpqwVOYEfQtJ3Bt0zkvaS0ll865olgqwMeta } from "/codebuild/output/src839969302/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeL0opUatrLaWRZp200R1jDfT8v_45Ko5uODMQGtx0NoiU4Meta } from "/codebuild/output/src839969302/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeqlSPVQB69_WzLpMrVm7gpfhJHZ_sX3BU1mL9ZNTbu0sMeta } from "/codebuild/output/src839969302/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordfIMGeH1C2tRV4boOk2D3r7nDDQVn0PZHaEoFp5NirmoMeta } from "/codebuild/output/src839969302/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias61PKd6pAMst9R0dsv861VAIeZBBI_0wUeRnQQXyoTisMeta } from "/codebuild/output/src839969302/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerQ4oOaRa4Kbc4qOeT9sz9_lQxn_45ag3eoQ1oAi0PSXXJQMeta } from "/codebuild/output/src839969302/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code_45QjNMNal_etFX3gLpCkndy_ZRK47yhR74APQjT1x7csMeta } from "/codebuild/output/src839969302/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexQf3iDtH2hpsnqI29l2iXZtgub61QSRYDCU82Oa64tAkMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexA_456Xjnudpepppd0ER1URVz5kJkzCjk0uMQr_CGUi4PIMeta } from "/codebuild/output/src839969302/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexR98XRWhA8hw8PBThPj6qrkiKkwuiZmf_MlB4_45fH7RCoMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexqPOLwyM2Sq1tE63_5CaUVsNszbSFvozD0REROwe2cSIMeta } from "/codebuild/output/src839969302/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateGuZ4R808zvqXKesJkw7s8BeFOvBYHTcdX1NHd4oDzQ0Meta } from "/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeLC2XEylMlJLM6Yl1rEM7jsW5M1izIbJJQxhggM2njs4Meta } from "/codebuild/output/src839969302/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmhSCzwkv1n_lm6f3QpbzeIqpGRmxM0a96MRR_kNWGh8YMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexWkIUvbOdYXCskUwD19WtJL04zQQUAg5lVtOC66zGv0cMeta } from "/codebuild/output/src839969302/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeKNQAlbvWvc7gY_452OWL2Iq8y_0V5XneNVpUATmgTmPoAMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatewT1K8yua2bibG_yA1AlQR4Aa_45pIzB9szzTgohz4a27sMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index6dd8Vctm91p92dsRgCo0d2Rz09LnkWgf2oPThpZUGhIMeta } from "/codebuild/output/src839969302/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexvc6BvLbZC06Vx6ah6GXeRIYgxFxOhM7bI8EvbRqOXq8Meta } from "/codebuild/output/src839969302/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeu36ixPrRgZ_45bxe2NXxfry3l3Gj60Vhbte2cLtAywOpsMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexPzL8YpoAFv9S4QCOamR8UW_45Q3xy__1_45JgQ2Cr2narMAMeta } from "/codebuild/output/src839969302/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeWhTivngJaveH1a6cLko6Qifd5vd5RWY4zDwY9yaQV5kMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexNEROJLU1WxdbYFiu_hKcQrF5jt_45gKg_HZaxe0zYXbPQMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index5kof_45fZUxLNFMkKEjGD9aZJjeNW8EtdljLZNXbcvpMcMeta } from "/codebuild/output/src839969302/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexx0fnsa1FrofUAdxfpOW7EzyPnV_WGmrpmLmZBE4rU1AMeta } from "/codebuild/output/src839969302/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateGS746BQhy4qjLhXsen_457vsEP4IpxKWRRj7WgNMKkNjAMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmQU_45vsT3QFt_gVnRyB_DO0FxiScYvxRno2K34lnMqI2UMeta } from "/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src839969302/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu5QyYz1d4PLBMcyj4iC3wjShero98_sv8VkYGpaNf0TsMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexPQOs9bCROpPq2Ze9uYyu7aO5N4p9Bl17gH_8pmIy2gYMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src839969302/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src839969302/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src839969302/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src839969302/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src839969302/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src839969302/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src839969302/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexi8bFSmPkUTlwOt5rq9oD7JWDMk1wIDPylx4ypqLchLoMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src839969302/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src839969302/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src839969302/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexZRk7RvGvUAvj8lSFct_i5bHufcYXErwEXsPhSMNfUdgMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src839969302/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src839969302/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexxV632rTsF9TkRNC8ozhm9L8FMsq_EFgwjthyOYTWdD4Meta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index0Pe09GVcKNiDV_hAJiVWhvD9nuwWjopj6ZA_R6Sr_4sMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src839969302/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src839969302/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src839969302/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src839969302/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src839969302/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexRSz31PkkVtTWodsCbSX3iBpzz9IZT8iDJN7eP2Z1rNQMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmMN1KkZ96mCy8fa2wh6ChocMDmCHlw50APMYAZ2Xbz2YMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmc_45NjzyH_F4Xuurj_Of636Hchm4vHz7TkadYF02IXsrsMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src839969302/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completenDLjZiSu0m9OXhXqT_5_Eor9v2eZ3Dew_LBlN8LRG5sMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerxbj1nQA1dkrzhZaQ1ejhaPQSBNpEeb_45k2IQUgmIm5TAMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm_Cr_Jumfxozz47OYbgfXNhxgVfA2iYLPdxCnNNaj0dUMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src839969302/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeyFmzNm9eSDZp7N1MH84k54CpiWDgtEK_xPAluKn7PwkMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeZV5Yx5XVjGN_45oa_45MSiepO_451nDZ5Lg6aY00nM9dISwyAMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeLwXicsPjlO0zGzHLYYUFiCrv4769Txj5q1SIWzLVSxQMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerSOITTUHIPaDR4pbrELcU03cVc2cCFdGil1YcjuCbQawMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src839969302/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirm9sXpgC41pIfYzw33QSWBqmj4BLW0B39D6xrJBpx1TMsMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeNDxL4Tv9MYwh8c23EP1Bmo1h_1FDIRW99hOZ9HlMHOgMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexqroS63owgDJgcLtDS8gZZM84uQSBN7UofZe5nLFLa0AMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completecyactynqxJaeEsDP92qpkWwUc0O76BG2bjhkN_XGfbAMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src839969302/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample2dTIqhHd_N_45pDdw7eNUzt8HruoRF4aewrKZF5faMh5EMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email_rL_pFywC_45fRmnLd7z7heI88vp_knHCX_8K69glnLq4Meta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmaG4y316rHGsyYNqTM7KEPsm8SvU1X94WOw_45PpBJU8kIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentgo46_45FYPQIT48A_453GL3c1wLVkv4CTPo4rWdQTrqPk8IMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm31KIoLeBqqr0HhsZbgaVyStMBejkpWbrRo_HSxMVv1gMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src839969302/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeL0opUatrLaWRZp200R1jDfT8v_45Ko5uODMQGtx0NoiU4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeqlSPVQB69_WzLpMrVm7gpfhJHZ_sX3BU1mL9ZNTbu0sMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordfIMGeH1C2tRV4boOk2D3r7nDDQVn0PZHaEoFp5NirmoMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src839969302/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerQ4oOaRa4Kbc4qOeT9sz9_lQxn_45ag3eoQ1oAi0PSXXJQMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code_45QjNMNal_etFX3gLpCkndy_ZRK47yhR74APQjT1x7csMeta || {},
    component: () => import("/codebuild/output/src839969302/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src839969302/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src839969302/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]